'use strict';
import * as $j_app$002edata$002e$002dDrug$002dRequest$002dPharmacy$002dResponse$0024 from "./app.data.-Drug-Request-Pharmacy-Response$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13() {
}
export { $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13 as $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13 };
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13.prototype.constructor = $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13;
/** @constructor */
function $h_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13() {
}
export { $h_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13 as $h_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13 };
$h_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13.prototype = $c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13.prototype;
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13.prototype.apply__O = (function() {
  return $j_app$002edata$002e$002dDrug$002dRequest$002dPharmacy$002dResponse$0024.$m_Lapp_data_DrugRequestPharmacyResponse$().schema__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13, "app.api.DrugRequestPharmacyState$ResponseGiven$$anon$13", ({
  Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13 as $d_Lapp_api_DrugRequestPharmacyState$ResponseGiven$$anon$13 };
//# sourceMappingURL=app.api.-Drug-Request-Pharmacy-State$-Response-Given$$anon$13.js.map
